var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vSelect',{attrs:{"options":_vm.stopOptions,"reduce":label => label.code,"label":"label"},model:{value:(_vm.stop),callback:function ($$v) {_vm.stop=$$v},expression:"stop"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }